import { useCallback, useEffect, useState } from "react";
import { TIMELINE_TYPE } from "../../../../constants";
import { VIEW_OPTIONS } from "../constants";

const useCalendarViewState = (isOpen: boolean) => {
  const [calendarInstance, setCalendarInstance] = useState<{ navigate: (date: Date) => void } | null>(null);
  const [view, setView] = useState(TIMELINE_TYPE.DAY);

  useEffect(() => {
    if (!isOpen) {
      setCalendarInstance(null);
    }
  }, [isOpen]);

  const handleCalendarInit = useCallback((event: { inst: { navigate: (date: Date) => void } | null }) => {
    setCalendarInstance(event.inst);
  }, []);

  const handleViewChange = useCallback((ev: CustomEvent) => {
    const selectedIndex = (ev.detail as number[])[0];
    const selectedView = VIEW_OPTIONS[selectedIndex]?.value;
    if (selectedView) {
      setView(selectedView);
    }
  }, []);

  return { calendarInstance, view, handleCalendarInit, handleViewChange };
};

export default useCalendarViewState;
